/*
  Find type of value
  It is an enchanced functionality of native typeof javascript method of finding the type of variable
  typeOf(); //undefined
  typeOf(null); //null
  typeOf(NaN); //number
  typeOf(5); //number
  typeOf({}); //object
  typeOf([]); //array
  typeOf(''); //string
  typeOf(function () {}); //function
  typeOf(/a/) //regexp
  typeOf(new Date()) //date
  typeOf(new Error) //error
  typeOf(Promise.resolve()) //promise
  typeOf(function *() {}) //generatorfunction
  typeOf(new WeakMap()) //weakmap
  typeOf(new Map()) //map
  typeOf(async function() {}) //asyncfunction

  https://stackoverflow.com/a/28475765
*/
export default function typeOf(obj) {
  return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
}
